
import * as React from "react";

import { TooltipOwnClanLevelIcon, DivTooltip } from "@wg/wows-react-uikit";

import { toRoman } from "../../../../helpers/formatting";
import { getClassClanLeverWrapper } from "../../../../helpers/supply";

import styles from "./OwnClanLevelIcon.scss";

export type IProps = {
  clanLevel: number;
  accumulativeClanResource: number;
  allBonusesActivated: boolean;
};

class OwnClanLevelIcon extends React.PureComponent<IProps, any> {

  render() {
    const classClanLeverWrapper = getClassClanLeverWrapper(this.props.clanLevel);
    const classNameBase = styles[`clan-level-wrapper-${classClanLeverWrapper}`];
    const clanLevelIconTooltipId = `clan-own-level-icon-tooltip-${this.props.clanLevel}`;

    return <div className={classNameBase}>
                {toRoman(this.props.clanLevel)}
                <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipOwnClanLevelIcon id={clanLevelIconTooltipId} clanLevel={this.props.clanLevel} accumulativeClanResource={this.props.accumulativeClanResource} allBonusesActivated={this.props.allBonusesActivated} />}>
                    {toRoman(this.props.clanLevel)}
                </DivTooltip>
            </div>;
  }
}

export default OwnClanLevelIcon;